import React from 'react';
import {useSelector, useDispatch} from "react-redux";
import {Animate} from "react-simple-animate";

import {incrementLoginStep, setSignUp, setLogin} from "../../../../Features/Misc/loginSlice"

import MediaFooter from "../../../Components/MediaFooter";
import SignupForm from "./SignupForm";
import Login from "../Signup/Login"
import EmailVerify from "./EmailVerify";
import EmailVerified from "./EmailVerified";
import ChooseSubscription from "./ChooseSubscription";
import BillingDetails from "./BillingDetails/BillingDetails";
import PaymentComplete from "./PaymentComplete";
import BackAndForthButton from "./BackAndForthButton";
import Footer from "../../../Components/Footer";


const useCode = process.env.REACT_APP_USE_CODE_4 === 'true';

export default function SignUpLeft(props) {

    //redux methods
    const dispatch = useDispatch();

    const takeMeToSignup = () => {
        dispatch(incrementLoginStep())
        dispatch(setSignUp())
    }

    const takeMeToLogin = () => {
        dispatch(incrementLoginStep())
        dispatch(setLogin())
    }

    //redux state
    const {loginStep, actionType} = useSelector((state) => state.login)

    const signupLeftSuperTitle = "A sleep toolbox that improves your sleep health"
    const signupLeftTitle = "Subscriptions/Memberships"
    const signupLeftCorporateTitle = "Corporate Account"
    const signupLeftCorporateText = "Direct Debit paid yearly, with the price based on the number of accounts required."
    const signupLeftIndividualTitle = "Individual Account"
    const signupLeftIndividualText = "As an individual user, pay monthly, 3-monthly, or for 12 months upfront, securely through Stripe"

    const WelcomeLeftColumnisation = " col-start-1 col-end-13  lg:col-end-9 text-center lg:text-left  "


    const welcomeStatus = (loginStep >= 1 ? " hidden lg:grid " : " grid ")

//gerry come back these were all lg:
    return (

        <>
            <div className={`lg:hidden row-start-1 row-end-13 col-start-2 col-end-12 grid grid-cols-12 grid-rows-12`}>
                {(actionType === "Sign Up" && loginStep === 1) && <SignupForm/>}
                {(actionType === "Log In" && loginStep >= 1) && <Login/>}
                {(actionType === "Sign Up" && loginStep === 2 && useCode === true) && <EmailVerify/>}
                {(actionType === "Sign Up" && loginStep === 3 && useCode === true) && <EmailVerified/>}
                {(actionType === "Sign Up" && loginStep === 2) && <ChooseSubscription />}
                {(actionType === "Sign Up" && loginStep === 3) && <BillingDetails/>}
                {(actionType === "Sign Up" && loginStep === 4) && <PaymentComplete/>}
            </div>

            <div
                className={` ${welcomeStatus} SignupLeft col-start-1 col-end-13 row-start-2 lg:row-start-4 row-end-13 grid-cols-12 grid-rows-12 `}>
                <Animate
                    play
                    start={{opacity: 0}}
                    end={{
                        opacity: 1,
                        display: "grid",
                        gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                        gridTemplateRows: "repeat(12, minmax(0, 1fr))",
                        gridRowStart: 1,
                        gridRowEnd: 13,
                        gridColumnStart: 1,
                        gridColumnEnd: 13
                    }}
                    duration={0.7}
                >
                    <div

                        className={`SignupLeft__superTitle lg:row-start-2 lg:row-end-3 text-lg font-semibold col-start-3 col-end-11 lg:col-start-1 lg:col-end-9 text-center lg:text-left `}>
                        {signupLeftSuperTitle}
                    </div>
                    <div
                        className={`SignupLeft__title text-2xl lg:text-4xl row-start-3 row-end-4 lg:row-start-2lg:row-end-3 text-center font-semibold   ${WelcomeLeftColumnisation}`}>
                        {signupLeftTitle}
                    </div>
                    <div
                        className={`SignupLeft__corporateTitle row-start-4 row-end-5 text-lg col-start-3 col-end-11 lg:col-start-1 lg:col-end-9 flex items-center justify-center lg:justify-start `}>
                        {signupLeftCorporateTitle}
                    </div>
                    <div
                        className={`SignupLeft__corporateText row-start-5 row-end-6 lg:row-start-5 lg:row-end-6 col-start-2 col-end-12 lg:col-start-1 lg:col-end-9  text-center  lg:text-left  `}>
                        {signupLeftCorporateText}
                    </div>
                    <div
                        className={`SignupLeft__individualTitle row-start-6 row-end-7 lg:row-start-7 lg:row-end-8 text-lg col-start-3 col-end-11 lg:col-start-1 lg:col-end-9 flex items-center justify-center lg:justify-start `}>
                        {signupLeftIndividualTitle}
                    </div>
                    <div
                        className={`SignupLeft__individualText row-start-7 row-end-9 lg:row-start-8 lg:row-end-9 col-start-2 col-end-12 lg:col-start-1 lg:col-end-9 bg text-center lg:text-left`}>
                        {signupLeftIndividualText}
                    </div>
                    <div
                        className={`SignupLeft__pagination flex px-2 row-start-8 row-end-9 col-start-6 col-end-8 lg:row-start-11 lg:row-end-12 lg:col-start-1 lg:col-end-12 items-center text-2xl justify-between`}>
                        <div className=" flex flex-row progressBar h-1 rounded-lg gap-2  w-20 ">
                            <div className="h1 bg-pink-dashboard rounded-lg w-6"></div>
                            <div className="h1 bg-pink-icon rounded-lg w-12"></div>
                        </div>
                        <div className="arrows-container hidden lg:flex flex-row gap-6">
                            <BackAndForthButton type="decrement"/>
                            <BackAndForthButton type="increment"/>
                        </div>
                    </div>
                    <div
                        className={`SignupLeft__buttonRow row-start-9 row-end-10 col-start-1 col-end-13 grid grid-cols-23 grid-rows-1  lg:hidden`}>
                        <div onClick={() => takeMeToSignup()}
                             className="SignupLeft__buttonRow__signUp border-3 border-gold-accent col-start-5 col-end-12 flex items-center justify-center h-12 rounded-lg  cursor-pointer">Sign
                            Up
                        </div>
                        <div onClick={() => takeMeToLogin()}
                             className="SignupLeft__buttonRow__logIn bg-gold-accent col-start-13 col-end-20 flex items-center justify-center h-12 rounded-lg  cursor-pointer">Log
                            In
                        </div>
                    </div>
                    <MediaFooter className={`col-start-1 col-end-13 row-start-11 row-end-12 flex items-center justify-center lg:hidden`}/>
                    <Footer className={`col-start-1 col-end-13 row-start-12 lg:row-start-13 text-sm row-end-13 text-pink-icon flex items-center justify-start`}/>
                </Animate>
            </div>
        </>
    );
}
